// We import the CSS which is extracted to its own file by esbuild.
// Remove this line if you add a your own CSS build pipeline (e.g postcss).

// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";
import Alpine from "alpinejs";
import { loadStripe } from "@stripe/stripe-js";
import * as Sentry from "@sentry/browser";
import persist from "@alpinejs/persist";
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import topbar from "../vendor/topbar";
import Hooks from "./hooks";
import phxFeedbackDom from "./phx_feedback_dom";

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");
let liveSocket = new LiveSocket("/live", Socket, {
  // We have to clone AlpineJS directives into the socket to prevent some
  // elements from ignoring x-show on live view mount.
  // See https://github.com/phoenixframework/phoenix_live_view/issues/996
  dom: phxFeedbackDom({
    onBeforeElUpdated(from, to) {
      if (from._x_dataStack) {
        window.Alpine.clone(from, to);
      }
    },
  }),
  hooks: Hooks,
  params: { _csrf_token: csrfToken },
});

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
window.addEventListener("phx:page-loading-start", (_info) => topbar.show(300));
window.addEventListener("phx:page-loading-stop", (_info) => topbar.hide());

// connect if there are any LiveViews on the page
liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;

if (window.STRIPE_PUB_KEY) {
  loadStripe(window.STRIPE_PUB_KEY).then((stripe) => {
    window.Stripe = stripe;
  });
}

window.Alpine = Alpine;
Alpine.plugin(persist);
Alpine.start();

window.SentryClient = Sentry;
document.dispatchEvent(new Event("SentryLoaded"));

function kdsHandleAction(actionEvent, selectedItemId, items) {
  items[selectedItemId].hide = true;
  pushEventHook.pushEvent(actionEvent, { id: selectedItemId });

  // Find minimum index item (that's not the just actioned item) and select it if it's in progress
  let minIndex = null,
    minId = null;
  Object.entries(items).forEach(([id, item]) => {
    if (id != selectedItemId && (!minIndex || item.index < minIndex)) {
      minIndex = item.index;
      minId = id;
    }
  });
  return minId && items[minId].status == "in_progress"
    ? items[minId]?.id
    : null;
}

window.kdsHandleAction = kdsHandleAction;
